<div mat-dialog-title class="u-textTruncate u-borderBottom-grey100">
  <ng-container
    *ngIf="isUser; else adminTitle"
    i18n="@@privateSegementsEditDialog.userTitle"
    >Edit private segments</ng-container
  >
  <ng-template #adminTitle>
    <ng-container i18n="@@privateSegementsEditDialog.adminTitle"
      >Edit {{ data.account.first_name }}'s private segments</ng-container
    >
  </ng-template>
</div>
<div mat-dialog-content class="u-showScrollBar u-borderBottom-grey100">
  <div class="u-paddingTop-16">
    <p
      *ngIf="isUser"
      class="text-body-2 color-grey u-marginBottom-24"
      i18n="@@privateSegmentsEditDialog.description"
    >
      Private segments are only visible to you and your Hub admin. Some private
      segments cannot be edited.
    </p>
    <form [formGroup]="segmentsSelectionsForm">
      @for (segment of segmentsToDisplay; track segment._id) {
        <div class="u-marginBottom-16">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
            <app-group-hidden-custom-segment-header
              [customSegment]="segment"
              [user]="data.user"
            ></app-group-hidden-custom-segment-header>
          </div>
          @switch (segment.selection_type) {
            @case ('single') {
              @if (segment.privacy_settings.editable_by_self || isUserAdmin) {
                <ng-container>
                  <nz-select
                    [formControlName]="segment._id"
                    class="u-width-100"
                    nzPlaceHolder="Select options"
                    i18n-nzPlaceHolder="
                      @@privateSegmentsEditDialog.selctOptionsPlaceholder"
                  >
                    @for (
                      option of singleSelectNodes[segment._id];
                      track $index
                    ) {
                      <nz-option
                        [nzLabel]="
                          option.label
                            | translationLookup: ['@@groupCustomSegmentOption']
                        "
                        [nzValue]="option.value"
                      ></nz-option>
                    }
                  </nz-select>
                </ng-container>
              }
              @if (!segment.privacy_settings.editable_by_self && !isUserAdmin) {
                @if (segmentsSelectionsForm.get(segment._id).value) {
                  <p>
                    {{
                      segmentsSelectionsForm.get(segment._id).value
                        | translationLookup: ['@@groupCustomSegmentOption']
                    }}
                  </p>
                }
                @if (!segmentsSelectionsForm.get(segment._id).value.length) {
                  <i i18n="@@global.notSpecifiedLabel">Not specified</i>
                }
              }
            }
            @case ('multi') {
              @if (segment.privacy_settings.editable_by_self || isUserAdmin) {
                <nz-select
                  [formControlName]="segment._id"
                  class="u-width-100"
                  nzMode="multiple"
                  nzPlaceHolder="Select options"
                  i18n-nzPlaceHolder="
                    @@privateSegmentsEditDialog.selctOptionsPlaceholder"
                  nzShowSearch
                  ><nz-option
                    *ngFor="let option of multiSelectNodes[segment._id]"
                    [nzLabel]="
                      option.title
                        | translationLookup: ['@@groupCustomSegmentOption']
                    "
                    [nzValue]="option.value"
                    nzCustomContent
                  >
                    <ng-container
                      [ngTemplateOutlet]="multiselectCheck"
                      [ngTemplateOutletContext]="{
                        formValue:
                          segmentsSelectionsForm?.value?.[segment?._id],
                        optionName: option.value,
                      }"
                    ></ng-container>
                    {{
                      option.title
                        | translationLookup: ['@@groupCustomSegmentOption']
                    }}
                  </nz-option>
                </nz-select>
              }
              @if (!segment.privacy_settings.editable_by_self && !isUserAdmin) {
                <div
                  fxLayout="row wrap"
                  fxLayoutAlign="start"
                  fxLayoutGap="8px"
                >
                  @if (!segmentsSelectionsForm.get(segment._id).value.length) {
                    <i i18n="@@global.notSpecifiedLabel">Not specified</i>
                  }
                  @for (
                    option of segmentsSelectionsForm.get(segment._id).value;
                    track $index
                  ) {
                    <app-chip class="u-display-block">{{
                      option | translationLookup: ['@@groupCustomSegmentOption']
                    }}</app-chip>
                  }
                </div>
              }
            }
          }
        </div>
      }
    </form>
  </div>
</div>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
  <div>
    <button mat-button mat-dialog-close i18n="@@global.cancel">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      [disabled]="!isFormValid || isLoading"
      (click)="
        updateHiddenSegmentSelections(
          data.membership,
          data.account,
          isUserAdmin,
          isUser
        )
      "
    >
      <span i18n="@@global.save">Save</span>
      <i
        *ngIf="isLoading"
        nz-icon
        nzType="sync"
        nzTheme="outline"
        nzSpin
        class="u-marginLeft-8"
      ></i>
    </button>
  </div>
</mat-dialog-actions>
<ng-template
  #multiselectCheck
  let-formValue="formValue"
  let-optionName="optionName"
>
  <mat-icon
    [ngStyle]="{ 'vertical-align': 'text-bottom' }"
    class="color-blue md-16"
  >
    @if (formValue.includes(optionName)) {
      check_box_outline
    } @else {
      check_box_outline_blank
    }
  </mat-icon>
</ng-template>
